<template>
  <v-container fluid>
    <section class="intro-section" id="home">
      <v-row class="align-center justify-center px-10" style="height: 690px">
<!--        <v-col md="6" cols="12" class="pa-1 font-weight-bold py-16">-->
<!--          <h2 class="display-3">Candidate <span class="green&#45;&#45;text">Polls</span> & <span-->
<!--              class="pink&#45;&#45;text">Popularity</span>-->
<!--            Check</h2>-->
<!--          <v-subheader>Hi, let us help you know your odds at elections.</v-subheader>-->
<!--          <br>-->
<!--          <br>-->
<!--          <v-btn large elevation="5" color="green" to="/register" class="white&#45;&#45;text mt-10 px-10 py-5">Sign Up</v-btn>-->
<!--          &lt;!&ndash;          <v-btn large elevation="5" color="pink" class="white&#45;&#45;text mt-10 ml-10 px-10 py-5">Contact Us&ndash;&gt;-->
<!--          &lt;!&ndash;          </v-btn>&ndash;&gt;-->
<!--          <v-row class="mt-16 hidden-sm-and-down">-->
<!--            <v-chip class="px-4 ma-3" color="primary">-->
<!--              <v-icon left size="20">mdi-facebook</v-icon>-->
<!--              Facebook-->
<!--            </v-chip>-->
<!--            <v-chip class="px-4 ma-3 white&#45;&#45;text" color="#01ff56">-->
<!--              <v-icon left size="20">mdi-whatsapp</v-icon>-->
<!--              WhatsApp-->
<!--            </v-chip>-->
<!--            <v-chip class="px-4 ma-3" color="info">-->
<!--              <v-icon left size="20">mdi-instagram</v-icon>-->
<!--              Instagram-->
<!--            </v-chip>-->
<!--          </v-row>-->
<!--        </v-col>-->
        <v-col cols="12" md="8">
          <v-row align="center" justify="center" v-if="loading">
            <v-col cols="12" sm="8">
              <v-progress-circular size="75" color="red" indeterminate/>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" v-if="!loading">
            <v-card-text class="mt-12 justify-center">
              <h2
                  class="text-center"
              >Login in to Your Account</h2>
              <h5
                  class="text-center  grey--text "
              >Log in to your account so you can continue </h5>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="8">
                  <v-form ref="form">
                    <v-text-field
                        label="Email"
                        outlined
                        v-model="userForm.email"
                        color="blue"
                        autocomplete="false"
                        class="mt-16"
                    />

                    <v-text-field
                        label="Password"
                        outlined
                        v-model="userForm.password"
                        color="blue"
                        autocomplete="false"
                        type="password"

                    />
                    <v-row>
                      <v-col cols="12" sm="7">
                        <v-checkbox
                            label="Remember Me"
                            v-model="userForm.remember_me"
                            class="mt-n1"
                            color="blue"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="5" link class="text-end">
                        <router-link to="/forgot-password">Forgot Password?</router-link>
                        <!--                        <v-btn x-small text class="caption blue&#45;&#45;text" @click="$router.push({name:'ForgotPassword'})">Forgot password</v-btn>-->
                      </v-col>
                    </v-row>
                    <v-btn color="blue" large dark block tile @click="login">Log in</v-btn>
                  </v-form>

                </v-col>
              </v-row>
            </v-card-text>
          </v-row>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import {postRequest} from "@/api/apirepository";
import {mapActions} from "vuex";

export default {
  metaInfo: {
    title: 'Login',
  },
  name: "Login",
  data() {
    return {
      loading: false,
      userForm: new Form({
        "email": "",
        "password": "",
        "remember_me": false
      }),
    }
  },
  methods: {
    ...mapActions([
      "addUser"
    ]),
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        postRequest('login', {
          email: this.userForm.email,
          password: this.userForm.password
        }).then(({data}) => {
          // console.log(data);
          if (data.access_token && data.access_token.length > 10) {
            toast.fire('Login Successful', '', 'success');
            localStorage.setItem('ptoken', data.access_token);
            this.loading = false;
            let user = data.user;
            this.addUser(data.user);
            // redirect user based on role
            if (data.user.type === 'sadmin') {
              this.$router.push({
                name: 'AdminDashboard'
              });
            } else if (data.user.type === 'admin') {
              this.$router.push({
                name: "UserDashboard"
              })
            }
          } else if (data.user.type === 'client') {
            this.$router.push({
              name: "ClientDashboard"
            })
          } else {
            localStorage.removeItem('ptoken');
            this.loading = false;
            toast.fire('Invalid credentials', '', 'warning');
            this.$router.push("/login")
          }
        }).catch(e => {
          this.loading = false;
          // console.log(e)
          // swal.fire(e.response.data.title, e.response.data.text, e.response.data.type)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>